var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('intersect',{on:{"enter":_vm.enable,"leave":_vm.disable}},[_c('canvas',{attrs:{"moz-opaque":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }